module.exports = __webpack_public_path__ + "static/media/allergenics.d15f2305.jpg";